import React from "react";
import { Button, Flex, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../Context/LoaderContext/LoaderContext";
import "./index.scss";
import TransitionWrapper from "../../Components/TransitionWrapper";
import { getPageMetaData } from "../../Utils/meta-data";
import { useAppContext } from "../../Context/AppContext/AppContext";
import PageMetadata from "../../Components/PageMetaData/PageMetaData";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { organization } = useAppContext();

  const handleGoToHome = () => {
    navigate("/");
  };
  const { isLoading } = useLoader();

  const meta = organization
    ? getPageMetaData("notfound", { organization })
    : getPageMetaData("notfound");

  return (
    <>
      <PageMetadata title={meta.title} description={meta.description} />
      <TransitionWrapper transitionType="slide-up">
        <section className="not-found">
          <div className="not-found-container">
            <Flex
              align="center"
              justify="center"
              style={{ flexDirection: "column", height: "100vh" }}
            >
              <Typography.Title level={1}>404</Typography.Title>
              <Typography.Paragraph>
                Sorry, the page you visited does not exist.
              </Typography.Paragraph>
              <Button
                type="primary"
                onClick={handleGoToHome}
                loading={isLoading}
              >
                Back Home
              </Button>
            </Flex>
          </div>
        </section>
      </TransitionWrapper>
    </>
  );
};

export default NotFound;
